export default __webpack_public_path__ + "static/media/btwn.66767fb5.png";